var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUntranslated = function SvgUntranslated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F65050"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.166 5.7a.7.7 0 0 0-.7.7v11.2a.7.7 0 0 0 .7.7h9.8a.7.7 0 0 0 .7-.7V6.4a.7.7 0 0 0-.7-.7h-9.8Zm.7 11.2V7.1h8.4v9.8h-8.4Zm3.295-8.196a.7.7 0 0 0-.99.99l.905.905-.905.905a.7.7 0 0 0 .99.99l.905-.905.905.905a.7.7 0 1 0 .99-.99l-.905-.905.905-.905a.7.7 0 0 0-.99-.99l-.905.905-.905-.905ZM9.266 14.8a.7.7 0 0 1 .7-.7h4.2a.7.7 0 1 1 0 1.4h-4.2a.7.7 0 0 1-.7-.7Z"
  })));
};
export default SvgUntranslated;